<template>
  <div>
          <v-layout wrap align-center white pa-0 class="area-conteudo anexo">
            <v-flex xs12 sm12>
                <div v-show="!deveMostrarBotaoAnexarReajuste">
                  <label><strong class="text--secondary mb-2">Arquivo anexado: </strong></label>
                  <p  class="text--secondary d-flex align-center text--lighten-2">
                      <v-icon size="20" class="mr-2"> fa fa-file-pdf</v-icon>
                    {{nomeArquivoEnviado}}
                  </p>
                </div>

              <compra-direta-upload-arquivo
                  v-if="deveMostrarBotaoAnexarReajuste"
                  :ref="'azFileUploadReadequacao' + itemOuLoteReajusteId"
                  :multiple="false"
                  @error="tratarErroEnvioArquivo"
                  @uploadArquivo="tratarEventUploadArquivoReadequacao"
                  accept="application/pdf"
                  class="anexo__botao">
                <a @click="selecionarAnexoReajuste" class="botao-anexar-readequacao">
                  <i class="fas fa-paperclip" aria-hidden="true"></i>
                  Anexar Arquivo
                </a>
              </compra-direta-upload-arquivo>
            </v-flex>

          </v-layout>
  </div>
</template>

<script>
import CompraDiretaUploadArquivo from '@/views/pages/commons/upload-arquivo/CompraDiretaUploadArquivo'

export default {
    name: 'AnexoReadequacao',
    components: {CompraDiretaUploadArquivo},
    props: {
        itemOuLoteReajusteId: {
            type: Number,
        },
        deveMostrarBotaoAnexarReajuste: {
            type: Boolean,
            default: true
        },
        nomeArquivoEnviado: {
            type: String,
            default: 'Arquivo enviado'
        }
    },
    methods: {
        selecionarAnexoReajuste() {
            this.$refs['azFileUploadReadequacao' + this.itemOuLoteReajusteId].openFileSelector()
        },
        async tratarEventUploadArquivoReadequacao(event){
            if (!this.extensaoArquivoValida(event.filename)) {
                this.mostrarNotificacaoErro('Extensão do arquivo inválida. Por favor, faça upload de um arquivo .pdf')
            } else {
                this.$emit('propagarEventoEnviarAnexoReadequacao', event.formData)
            }
        },
        extensaoArquivoValida(nomeArquivo) {
            const extensao = nomeArquivo.substr(nomeArquivo.lastIndexOf('.'), nomeArquivo.length)
            return extensao === '.pdf' || extensao === '.PDF'
        },
    }
}
</script>

<style scoped lang="stylus">
    a.botao-anexar-readequacao
        background-color var(--v-secondary-base) !important
        border 1px solid var(--v-secondary-base) !important
        color white !important
        display block
        height 75px !important
        width 150px !important
        justify-content center !important
        align-items center !important
        text-align center !important

    a.botao-anexar-readequacao:hover, a.botao-anexar-readequacao:active, a.botao-anexar-readequacao:focus
        background-color var(--v-primary-lighten2) !important
        border 1px solid var(--v-primary-lighten2) !important
        color: white !important
        -webkit-box-shadow 0 2px 2px 0 #AAAAAA !important

    a.botao-anexar-readequacao:hover i, a.botao-anexar-readequacao:active i, a.botao-anexar-readequacao:focus i
        color white !important

    a.botao-anexar-readequacao i
        color white !important
        font-size 30px
        top 0
        display block


    @media (max-width 991px)
        .anexo .flex
            padding-right 0
            margin-bottom 20px

        .botao-assinado
            background-color #fff
            color #888
            padding 5px 10px 5px 5px
            min-width 50px

            i
                color #777 !important
                font-size 13px
                top 0

</style>
